import { render, staticRenderFns } from "./PhoneField.vue?vue&type=template&id=a70201b8&scoped=true&"
import script from "./PhoneField.vue?vue&type=script&lang=js&"
export * from "./PhoneField.vue?vue&type=script&lang=js&"
import style0 from "./PhoneField.vue?vue&type=style&index=0&id=a70201b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70201b8",
  null
  
)

export default component.exports